import React from 'react';
import './IOSSpotifySetup.css';

function IOSSpotifySetup({ isSpotifyAppOpen, onContinue }) {
  return (
    <div className="ios-spotify-setup-overlay">
      <div className="ios-spotify-setup-container">
        <div className="ios-spotify-setup-content">
          <h2>Spotify Setup Required</h2>

          {isSpotifyAppOpen ? (
            <>
              <div className="setup-instructions">
                <p className="instruction-main">
                  Play any Song on your Spotify App.
                </p>
                <p className="instruction-sub">
                  Let the Song play and come back and play another Song from here to get started
                </p>
              </div>
              <div className="setup-icon">🎵</div>
            </>
          ) : (
            <>
              <div className="setup-instructions">
                <p className="instruction-main">
                  Open your Spotify App. Play any Song on your Spotify App.
                </p>
                <p className="instruction-sub">
                  Let the Song play and come back and play another Song from here to get started
                </p>
              </div>
              <div className="setup-icon">📱</div>
            </>
          )}

          <button
            className="ios-continue-button"
            onClick={onContinue}
          >
            I've started playing a song on Spotify
          </button>

          <p className="setup-note">
            Note: Make sure you have Spotify installed and are logged in.
          </p>
        </div>
      </div>
    </div>
  );
}

export default IOSSpotifySetup;